import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import Additionstowage from './additionstowage.jsx';

export default class ThisDriversArchivedAdditionstowages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      url: props.url || '/api/v1/portal/drivers/additionstowages',
      additionstowageAccountId: props.additionstowageAccountId || null,
    };
  }

  componentDidMount() {
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/additionstowages/'+
      this.state.additionstowageAccountId+'/archived',
      method: 'GET',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(additionstowagesJson) {
      that.setState({
        additionstowages: additionstowagesJson,
        isLoading: false
      });
    });
  }

  render() {
    var Additionstowagearr = [];

    if (this.state.additionstowages && this.state.additionstowages.length > 0) {
      this.state.additionstowages.forEach(function(i) {
        Additionstowagearr.push(<Additionstowage key={'additionstowage-'+i.id} data={i} />);
        });
    }
    return (
        <div>
            <div className="row additionstowages-table-header">
                <div className="col-md-3">
                    description
                </div>
                <div className="col-md-3">
                    reference
                </div>
                <div className="col-md-2">
                    amounts
                </div>
                <div className="col-md-2">
                    frequency
                </div>
                <div className="col-md-2">
                    details
                </div>
            </div>
            {Additionstowagearr}
        </div>
    );
  }
}
